export default __webpack_public_path__ + "static/media/CESLogo.e0dfb995.svg";